import { useEffect, useRef, useState } from "react";
import { getMethod2 } from "../functions/httpMethods";
import ReusableSelect from "./general/ReusableSelect";

const EnhancedFilter = ({ label, endpoint, value, onChange, dependencies }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);

  const cache = useRef({});

  const fetchOptions = async () => {
    if (fetched) return;
    console.log("here");
    setLoading(true);

    await getMethod2(endpoint, "").then((response) => {
      console.log(response);
      setFetched(true);

      cache.current[endpoint] = response;
      setOptions(response);
      setLoading(false);
    });
  };

  // Reset fetched state when endpoint changes
  useEffect(() => {
    setFetched(false);
  }, [endpoint]);

  return (
    <>
      <ReusableSelect
        loading={loading}
        onFocus={fetchOptions}
        type={"filter"}
        label={label}
        width={200}
        marginRight={40}
        bgColor="#FFF"
        state={value}
        setState={onChange}
        options={options.map((o) => ({
          value: o.filter_id,
          option: o.filter_name,
        }))}
      />
    </>
  );
};

export default EnhancedFilter;
